import { createAction, props } from '@ngrx/store';
import { IsUserLockedRequest, IsUserLockedResponse, IUserLockedUpdateRequest, IUserLockedUpdateResponse } from '../models/lock.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

//Check if User is locked-----------------------------
export const checkUserLockedRequest = createAction('[Locked] Load locked check request', props<{ request: IsUserLockedRequest }>());

export const checkUserLockedResponse = createAction('[Locked] Load locked check Success', props<{ response: IsUserLockedResponse }>());

export const checkUserLockedFailure = createAction('[Locked] Load locked check Failure', props<{ error: IGenericError<ErrorResponse> }>());

// Updating if user is locked
export const loadLockedRequest = createAction('[Locked] Load locked request', props<{ request: IUserLockedUpdateRequest }>());

export const loadLockedResponse = createAction('[Locked] Load locked Success', props<{ response: IUserLockedUpdateResponse }>());

export const loadLockedFailure = createAction('[Locked] Load locked Failure', props<{ error: IGenericError<ErrorResponse> }>());

// send new passcode actions
export const loadUnLockedRequest = createAction('[Locked] Load unlocked request', props<{ request: IUserLockedUpdateRequest }>());

export const loadUnLockedResponse = createAction('[Locked] Load unlocked Success', props<{ response: IUserLockedUpdateResponse }>());

export const loadUnLockedFailure = createAction('[Locked] Load unlocked Failure', props<{ error: IGenericError<ErrorResponse> }>());
